import { FormValidationSchema } from '@/common/interfaces';

export enum ReferralLinksFormInputs {
  Url = 'url',
  IsActive = 'isActive',
  IsFrequencyLocked = 'isFrequencyLocked',
  ReferralId = 'referralId',
  SiteId = 'siteId',
  AppearanceFrequency = 'appearanceFrequency',
  Links = 'links',
  Id = 'id',
  IsNew = 'isNew',
  IsRemoved = 'isRemoved',
}

export type ReferralLinksFormFields = {
  links: {
    id: string;
    url: string;
    isActive: boolean;
    isFrequencyLocked: boolean;
    referralId: string;
    siteId: string;
    appearanceFrequency: number;
    isNew: boolean;
    isRemoved: boolean;
  }[];
};

export type ReferralLinkFormValidationSchema = FormValidationSchema<ReferralLinksFormFields>;

export const ReferralLinksLimit = 10;
